import { ICalendar } from 'datebook'
import * as FileSaver from 'file-saver'

export const AddToCalendar = (startDate: string, endDate: string, CalendarTitleMessage: string, CalendarDescriptionMessage: string) => {
    const config: any = {
        title: CalendarTitleMessage,
        description: CalendarDescriptionMessage,
        start: new Date(startDate), // Start date of the callback window
        end: new Date(endDate), // End date of the callback window
    };

    const icalendar = new ICalendar(config)

    // fs.writeFileSync('my-event.ics', icalendar.render());

    //icalendar.download("test123");
    const ics = icalendar.render()
    const blob = new Blob([ics], {
        type: 'text/calendar'
    })

    FileSaver.saveAs(blob, 'my-calendar-event.ics')
}